<template>
  <el-drawer
    :visible="visible"
    size="60%"
    :append-to-body="true"
    :destroy-on-close="true"
    :wrapper-closable="false"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <div slot="title" style="display: flex; justify-content: space-between">
      <div>查看UDI</div>
      <div>
        <el-button @click="$emit('close')"> 返回</el-button>
      </div>
    </div>
    <div style="display: flex; justify-content: end">
      <el-input
        v-model.trim="queryParams.code"
        placeholder="UDI码"
        clearable
        style="width: 200px"
      >
      </el-input>
      <el-button size="mini" type="primary" @click="fetchData"> 搜索</el-button>
    </div>

    <el-table
      ref="table"
      height="500"
      :data="paginatedList"
      style="width: 100%; margin-top: 12px"
      border
      stripe
    >
      <el-table-column prop="code" label="UDI码" show-overflow-tooltip />
      <el-table-column v-if="isBatchCode" prop="number" label="入库数量" />
      <el-table-column v-else label="操作" width="150">
        <template slot-scope="scope">
          <el-button  type="text" @click="handleRemove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      style="margin-top: 24px"
      :total="total"
      :page-sizes="[10, 50, 100, 300]"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="fetchData"
    />
  </el-drawer>
</template>

<script>
import { getStockInCodeList, removeStockInCodeList } from "@/api/warehousingOrder";

export default {
  name: 'UdiCheckReview',
  props: {
    visible: {
      type: Boolean,
      default: () => {
        return false
      }
    },

    id: {
      type: String,
      default: () => {
        return ''
      }
    },
    isBatchCode: {
      type: Boolean,
      default: () => {
        return false
      }
    },
  },

  data: () => {
    return {
      udiDataList: [],
      paginatedList: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        inProductId: '',
        code: '',
      }
    }
  },
  mounted() {
    this.queryParams.inProductId = this.id
    this.fetchData() // 重新加载分页数据
  },
  methods: {
    handleRemove(row) {
      if(this.total <= 1) {
        this.$message.warning('UDI码列表不能为空')
        return
      }
      this.$confirm('是否删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeStockInCodeList([row.id]).then(() => {
          this.queryParams.pageNum = 1
          this.$message.success('删除成功')
          this.fetchData(() => {
            this.$emit('removeUdi', row, this.total)
          })
        })
      })
    },
    fetchData(callback = ()=>{}) {
      getStockInCodeList(this.queryParams).then(res => {
        if (this.isBatchCode && res.total>0) {
          this.paginatedList = [{
            code: res.rows[0].code,
            number: res.rows[0].number,
          }]
          this.total = 1
        } else {
          this.paginatedList = res.rows
          this.total = res.total
        }
        callback()
      })
    }
  }
}
</script>

<style scoped>
.tips {
  margin-bottom: 12px;
  font-size: 14px;
  color: #fa8c16;
}
</style>
